module.exports = __webpack_public_path__ + "img/ultrastock.b3137f64.png";